import api from './api';

// 사용자 데이터 타입 정의
export interface User {
  id: number;
  username: string;
  email: string;
  name: string;
  phone: string;
  role: 'admin' | 'super_admin' | 'development_admin';
  isActive: boolean;
  lastLogin: string | null;
  createdAt: string;
  updatedAt: string;
}

// 사용자 목록 응답 타입
export interface UsersResponse {
  success: boolean;
  data: {
    users: User[];
    pagination: {
      currentPage: number;
      totalPages: number;
      totalItems: number;
      itemsPerPage: number;
    };
  };
}

// 사용자 생성 요청 타입
export interface CreateUserRequest {
  username: string;
  email: string;
  password: string;
  name: string;
  phone: string;
  role: 'admin' | 'super_admin' | 'development_admin';
}

// 사용자 수정 요청 타입
export interface UpdateUserRequest {
  username?: string;
  email?: string;
  name?: string;
  phone?: string;
  role?: 'admin' | 'super_admin' | 'development_admin';
  isActive?: boolean;
}

// 중복 확인 응답 타입
export interface DuplicateCheckResponse {
  success: boolean;
  data: {
    isDuplicate: boolean;
    message: string;
  };
}

// 사용자 관리 API 서비스
export const usersApi = {
  // 사용자 목록 조회
  getUsers: async (params?: {
    page?: number;
    limit?: number;
    search?: string;
    role?: string;
    isActive?: boolean;
  }): Promise<UsersResponse> => {
    const response = await api.get('/users', { params });
    return response.data;
  },

  // 사용자 상세 조회
  getUser: async (id: number): Promise<{ success: boolean; data: User }> => {
    const response = await api.get(`/users/${id}`);
    return response.data;
  },

  // 사용자 생성
  createUser: async (userData: CreateUserRequest): Promise<{ success: boolean; data: User; message: string }> => {
    const response = await api.post('/users', userData);
    return response.data;
  },

  // 사용자 수정
  updateUser: async (id: number, userData: UpdateUserRequest): Promise<{ success: boolean; data: User; message: string }> => {
    const response = await api.put(`/users/${id}`, userData);
    return response.data;
  },

  // 사용자 삭제
  deleteUser: async (id: number): Promise<{ success: boolean; message: string }> => {
    const response = await api.delete(`/users/${id}`);
    return response.data;
  },

  // 비밀번호 재설정
  resetPassword: async (id: number, newPassword: string): Promise<{ success: boolean; message: string }> => {
    const response = await api.put(`/users/${id}/reset-password`, { newPassword });
    return response.data;
  },

  // ID/이메일 중복 확인
  checkDuplicate: async (type: 'username' | 'email', value: string, excludeId?: number): Promise<DuplicateCheckResponse> => {
    const params: any = { type, value };
    if (excludeId) {
      params.excludeId = excludeId;
    }
    const response = await api.get('/users/check-duplicate', { params });
    return response.data;
  },

  // 사용자 일괄 삭제
  bulkDeleteUsers: async (ids: number[]): Promise<{ success: boolean; message: string; data: { deletedCount: number } }> => {
    const response = await api.post('/users/bulk-delete', { ids });
    return response.data;
  }
};

export default usersApi;